import { type FC } from 'react';
import cn from 'classnames';

import { getImage } from '@/common/lib/images';
import { toShortNumFormat } from '@/common/lib/toShortNumFormat';
import { type TicketRewardType } from '@/common/types/lottery';
import { walletImages } from '@/components/helpers/imagesImports';
import { Picture } from '@/components/ui/Picture/Picture';
import { TicketIcon } from '@/components/ui/TicketIcon/TicketIcon';

import css from './styles.module.scss';

interface RewardItemProps {
  item: string;
  quantity: number;
}

const RewardItem: FC<RewardItemProps> = ({ item, quantity }) => {
  const ticketsRewars = ['silverTicket', 'goldTicket', 'diamondTicket'];
  const walletImage =
    item in walletImages
      ? walletImages[item as keyof typeof walletImages]
      : undefined;
  const resourceImage = !(item in walletImages)
    ? getImage({ name: item, field: 'icon' })
    : undefined;

  const isTicketReward = ticketsRewars.includes(item);

  return (
    <div className="flex flex-col items-center gap-[2px] relative">
      {isTicketReward ? (
        <TicketIcon
          type={item as TicketRewardType}
          className="w-[32px] h-[32px] shrink-0"
        />
      ) : (
        <Picture
          img={walletImage ? walletImage.png : resourceImage?.img}
          webp={walletImage ? walletImage.webp : resourceImage?.webp}
          className="w-[32px] h-[32px] shrink-0"
          alt={item}
        />
      )}
      <span className="text-[12px] leading-none font-bold text-white">
        {toShortNumFormat(quantity)}
      </span>
      {!!walletImage ||
        (isTicketReward && (
          <span className={cn(css.effect, css[`effect--${item}`])}></span>
        ))}
    </div>
  );
};

export { RewardItem };
